export enum MethodList {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    PATCH = 'PATCH',
    DELETE = 'DELETE',
}

export function listHTTPMethods(): MethodList[] {
    return Object.values(MethodList);
}
